export var isValidEmail = function (str) {
    var re = new RegExp(/^\S+@\S+$/);
    return re.test(str);
};
